import { UserEventV2 } from "@backend-types";
import Ajv from "ajv";
import addFormats from "ajv-formats";
import schema from "./PostMessagePayloadSchema.json";
import schemaOrchard from "./OrchardPostMessagePayloadSchema.json";
const ajv = new Ajv();
addFormats(ajv);

export type EventPayload = Pick<
  UserEventV2,
  | "type"
  | "contents"
  | "created_at"
  | "status"
  | "learning_objectives"
  | "skill_ids"
  | "current_hint_level"
  | "total_hint_levels"
> &
  GradePayload;
type GradePayload = {
  points?: number;
  maxPoints?: number;
};

// Compile the schema
const validate = ajv.compile(schema);
const validateOrchard = ajv.compile(schemaOrchard);

export function validateEventData(data: any): boolean | void {
  const valid = validate(data);
  if (!valid) {
    // console.error(validate.errors);
    return false;
  }
  return true;
}

export function validateOrchardEventData(data: any): boolean | void {
  const valid = validateOrchard(data);
  if (!valid) {
    // console.error(validate.errors);
    return false;
  }
  return true;
}
